import RoutesMap from "../../route_control/RouteControl"
import {
    CurrencyList,
    AddCurrency,
    UpdateCurrency,
    CostCenterList,
    AddCostCenter,
    UpdateCostCenter,
    TaxList,
    AddTax,
    UpdateTax,
    TaxTypeList,
    AddTaxType,
    UpdateTaxType,
    SubMenuList,
    AddSubMenu,
    UpdateSubMenu,
    MainMenuList,
    AddMainMenu,
    UpdateMainMenu,
    CountryList,
    AddCountry,
    UpdateCountry,
    StateList,
    AddState,
    UpdateState,
    CityList,
    AddCity,
    UpdateCity,
    CompanyList,
    AddCompany,
    UpdateCompany,
    CompanyBusinessAreaList,
    AddCompanyBusinessArea,
    UpdateCompanyBusinessArea,
    BusinessAreaWareHouseList,
    AddBusinessAreaWareHouse,
    UpdateBusinessAreaWareHouse,
    RoleList,
    AddRole,
    UpdateRole,
    PermissionMenuList,
    AddPermissionMenu,
    UpdatePermissionMenu,
    UserRoleList,
    AddUserRole,
    UpdateUserRole,
    AssignRolePermission,
} from "../../pages/user_management"

export const UserManagementImport = {
    RoutesMap,
    CurrencyList,
    AddCurrency,
    UpdateCurrency,
    CostCenterList,
    AddCostCenter,
    UpdateCostCenter,
    TaxList,
    AddTax,
    UpdateTax,
    TaxTypeList,
    AddTaxType,
    UpdateTaxType,
    SubMenuList,
    AddSubMenu,
    UpdateSubMenu,
    MainMenuList,
    AddMainMenu,
    UpdateMainMenu,
    CountryList,
    AddCountry,
    UpdateCountry,
    StateList,
    AddState,
    UpdateState,
    CityList,
    AddCity,
    UpdateCity,
    CompanyList,
    AddCompany,
    UpdateCompany,
    CompanyBusinessAreaList,
    AddCompanyBusinessArea,
    UpdateCompanyBusinessArea,
    BusinessAreaWareHouseList,
    AddBusinessAreaWareHouse,
    UpdateBusinessAreaWareHouse,
    RoleList,
    AddRole,
    UpdateRole,
    PermissionMenuList,
    AddPermissionMenu,
    UpdatePermissionMenu,
    UserRoleList,
    AddUserRole,
    UpdateUserRole,
    AssignRolePermission,
}